"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fracText = fracText;
exports.toWordsMoney = toWordsMoney;
const mround_1 = require("./mround");
const padNumber_1 = require("./padNumber");
const toWords_1 = require("./toWords");
/**
 * tekst złotych
 * @param value liczba złotych
 */
function intText(value) {
    if (value === 1) {
        return 'złoty';
    }
    const decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'złotych';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'złote';
    }
    return 'złotych';
}
/**
 * tekst groszy
 * @param value liczba groszy
 */
function fracText(value) {
    if (value === 1) {
        return 'grosz';
    }
    const decValue = value % 100;
    if (decValue >= 5 && decValue <= 20)
        return 'groszy';
    switch (decValue % 10) {
        case 2:
        case 3:
        case 4:
            return 'grosze';
    }
    return 'groszy';
}
/**
 * Zamiana kwoty na słownie ze słowem złoty/ch
 * @param value kwota do zamiany
 * @param currency co wstawić jako walutę, domyslnie automatycznie dopasowuje odmianę `złoty`
 * @param forceShowgr czy wymusić grosze w przypadku gdy liczba groszy jest równa 0
 */
function toWordsMoney(value, currency = '', forceShowgr = false) {
    if (value < 0) {
        value = value * -1;
    }
    let strValue = '';
    const intValue = Math.floor(value);
    const fracValue = (0, mround_1.mround)((value - intValue) * 100, 0);
    if (!currency) {
        currency = intText(intValue);
    }
    strValue = (0, toWords_1.toWords)(intValue) + ' ' + currency;
    if (fracValue !== 0 || forceShowgr) {
        strValue += ' ' + (0, padNumber_1.padNumber)(fracValue, 2) + '/100';
    }
    return strValue;
}
//# sourceMappingURL=toWordsMoney.js.map